import { render, staticRenderFns } from "./BlogUnauthDetails.vue?vue&type=template&id=1b478fa7&scoped=true"
import script from "./BlogUnauthDetails.vue?vue&type=script&lang=js"
export * from "./BlogUnauthDetails.vue?vue&type=script&lang=js"
import style0 from "./BlogUnauthDetails.vue?vue&type=style&index=0&id=1b478fa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b478fa7",
  null
  
)

export default component.exports